import { render, staticRenderFns } from "./FileUploadList.vue?vue&type=template&id=06b32f96&scoped=true&"
import script from "./FileUploadList.vue?vue&type=script&lang=js&"
export * from "./FileUploadList.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadList.vue?vue&type=style&index=0&id=06b32f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b32f96",
  null
  
)

export default component.exports